import { ExistingProvider, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

export class ControlValueAccessorUtils {
  public static getProvider<T>(component: T): ExistingProvider {
    return {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => component),
      multi: true
    };
  }
}

